import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { clickButton } from '../../actions/Modal';
import {
    HomeworkStatusTypes,
    LectureProgressContentTypes,
} from '../../Constants';
import BaseComponent from './BaseComponent';
import Title from '../CommonSet/Title';
import Button from '../CommonSet/Button';
import LectureIndicator from '../CommonSet/LectureIndicator';
import Style from './LectureProgress.cssmodule.less';

class LectureProgress extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
    }

    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'LECTURE_PROGRESS');
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    handleIndicatorClick(event, data) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
            data,
        });
    }

    createFootNote() {
        const { homeworkStatus, name } = this.props.item;

        const footNote = [];
        const footNoteList = [
            {
                text: this.Utils.getLang('Menus.in_progress'),
                name: 'progress',
            },
            {
                text: this.Utils.getLang('Menus.completed'),
                name: 'completed',
            },
        ];

        if (
            [
                HomeworkStatusTypes.HOMEWORK,
                HomeworkStatusTypes.DUE_LAPSE,
            ].indexOf(homeworkStatus) > -1
        ) {
            footNoteList.push({
                text: this.Utils.getLang('Menus.submitted'),
                name: 'submitted',
            });
            footNoteList.push({
                text: this.Utils.getLang('Menus.submission_closed'),
                name: 'resolved',
            });
        }

        footNoteList.forEach((item, i) => {
            footNote.push(
                <div key={`footNote${i}`} className={this.Style[item.name]}>
                    <div className={this.Style.image} />
                    <div>{item.text}</div>
                </div>
            );
        });
        return (
            <div className={this.Style.footNote}>
                {name && <div className={this.Style.curriculum_title}>{name}</div>}
                {footNote}
            </div>
        );
    }

    createCurriculumList() {
        const curriculumList = [];
        const { homeworkStatus } = this.props.item;

        this.props.item.content.forEach((item, lectureIndex) => {
            curriculumList.push(
                <div
                    key={`curriculumList${lectureIndex}`}
                    className={this.Style.curriculumList}
                >
                    <div className={this.Style.lectureName}>{item.title}</div>
                    <LectureIndicator
                        theme={this.props.theme}
                        className={this.Style.lectureIndicator}
                        content={item.data}
                        homeworkStatus={homeworkStatus}
                        onClick={(event, studyIndex) => {
                            this.handleIndicatorClick('select', {
                                lectureIndex,
                                studyIndex,
                            });
                        }}
                    />
                </div>
            );
        });

        return <div className={this.Style.curriculumListView}>{curriculumList}</div>;
    }

    createLectureList() {
        const lectureList = [];
        const { homeworkStatus } = this.props.item;

        this.props.item.content.forEach((item, studentIndex) => {
            lectureList.push(
                <div
                    key={`lectureList${studentIndex}`}
                    className={this.Style.lectureList}
                >
                    <div className={this.Style.lectureListIndex}>
                        {this.Utils.zeroFill(studentIndex + 1, 2)}
                    </div>
                    <div className={this.Style.lectureListName}>{item.name}</div>
                    <div>
                        <LectureIndicator
                            className={this.Style.lectureIndicator}
                            content={item.data}
                            homeworkStatus={homeworkStatus}
                            onClick={(event, studyIndex) => {
                                this.handleIndicatorClick('select', {
                                    studentIndex,
                                    studyIndex,
                                });
                            }}
                        />
                    </div>
                </div>
            );
        });

        return (
            <div className={this.Style.lectureListView}>
                <div className={this.Style.lectureListHeader}>
                    <div className={this.Style.lectureListHeaderIndex}>#</div>
                    <div className={this.Style.lectureListHeaderName}>
                        {this.Utils.getLang('Menus.group_username')}
                    </div>
                    <div>{this.Utils.getLang('Menus.progress')}</div>
                </div>
                <hr className={this.Style.lectureListDivider} />
                {lectureList}
            </div>
        );
    }

    render() {
        const { contentType, closeButtonText } = this.props.item;

        return (
            <div className={this.Style.lectureProgress}>
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    {this.props.item.title}
                </Title>

                <div className={this.Style.contentView}>
                    {this.createFootNote()}

                    <div className={this.Style.content}>
                        {contentType === LectureProgressContentTypes.CURRICULUM
                            ? this.createCurriculumList()
                            : this.createLectureList()}
                    </div>

                    <div className={this.Style.buttonView}>
                        <Button
                            className={this.Style.button}
                            onClick={(e) => {
                                this.handleButtonClick('close');
                            }}
                            text={
                                closeButtonText ||
                                this.Utils.getLang('Buttons.confirm')
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

LectureProgress.displayName = 'LectureProgress';
LectureProgress.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(LectureProgress);



// WEBPACK FOOTER //
// ./components/ModalSet/LectureProgress.js